import React, { Component } from "react";
import { Link } from "react-router";
import Notice from "../../../notice/Notice";

import ProfilePublicationList from "./ProfilePublicationList";

export function isDisabled() {
  return new Date() > new Date(Date.UTC(2025, 11, 31, 23));
}

class ProfilePublicationPage extends Component {
  render() {
    return (
      <div className="container content">
        <section className="row">
          {isDisabled() ? (
            <Notice>
              <p>
                As of 31 December 2025, the option to enter publications
                directly in Forschungsmonitoring has been discontinued. For the
                upcoming VWL ranking 2026, we will use publications data from
                ORCID, a global, not-for-profit organization. This change will
                reduce your workload, as many publishers automatically add
                publications to your ORCID profile when you provide your ORCID
                number during the publication process. Additionally, you may
                manually enter your publications into your ORCID profile. This
                is also easier with ORCID than with the Forschungsmonitoring
                website, as your coauthors do not need to have an ORCID profile.
              </p>
              <p>
                To make sure your publications are included in the next and all
                future rankings, you must take the following steps:
              </p>
              <ol>
                <li>
                  {" "}
                  Register on https://orcid.org/ if you have not already done
                  so, and ensure your ORCID Number is correctly included in your
                  Forschungsmonitoring profile.
                </li>
                <li>
                  Ensure that all your relevant publications since 2023 are
                  included on your ORCID account with their respective DOI
                  numbers. Importantly, we can only include publications with a
                  valid DOI.
                </li>
                <li>
                  Publications already added to the Forschungsmonitoring website
                  in the past will be considered as well, so that only new
                  publications must show up on your ORCID profile.
                </li>
              </ol>
              <p>Further explanations:</p>
              <p>
                This change is part of the planned continuation of the VWL
                ranking, which is scheduled to come out in the summer/fall of
                2026. Please note that there will be no ranking and no weighting
                scheme published in 2025. The 2026 ranking will be implemented
                in a simplified form due to budget constraints: Relying on the
                ORCID database allows us to reduce the annual cost, making a
                continuation of the ranking feasible. Furthermore, the BWL
                ranking will not be continued. The current status of the
                Forschungsmonitoring ranking is still preliminary and may be
                subject to further adjustments. We appreciate your understanding
                during this transition phase, and we will provide a general
                update to all registered researchers soon. In the meantime, for
                questions, please contact:{" "}
                <a href="mailto:kontakt@forschungsmonitoring.org">
                  kontakt@forschungsmonitoring.org
                </a>
              </p>
            </Notice>
          ) : (
            /* <Notice> */
            /*   Modifications to publications will be disabled starting 01.01.2026 */
            /* </Notice> */
            ""
          )}
        </section>
        <section className="row">
          <h1>Publications</h1>
          <Link to="/profile/publication/editor" className="pull-right">
            <button className="btn btn-primary" disabled={isDisabled()}>
              Add a Publication
            </button>
          </Link>
        </section>
        <ProfilePublicationList />
      </div>
    );
  }
}

export default ProfilePublicationPage;
